import React, { FC } from 'react';
import { type IconV2Props } from '../../IconV2';
import { cn } from '@express-labs/raven-tools';
import getDataIconAttribute from '../../helpers/getDataIconAttribute';
import s from '../../IconV2.scss';

const Snapchat24: FC<IconV2Props> = ({ icon, chroma }) => (
  <svg
    className={cn(
      chroma === 'dark' ? s.svgLight24 : s.svgDark24,
      `svg-icon--${icon}`
    )}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    data-icon={getDataIconAttribute(chroma, icon, '24')}
  >
    <path
      d="M12.101 20c-.041 0-.082-.001-.122-.003a1.007 1.007 0 01-.08.003c-.948 0-1.557-.43-2.145-.845-.406-.287-.79-.557-1.241-.632a4.021 4.021 0 00-.652-.055c-.382 0-.683.058-.903.101a1.981 1.981 0 01-.337.05c-.091 0-.19-.02-.233-.168a5.31 5.31 0 01-.091-.37c-.067-.308-.115-.497-.244-.517-1.503-.231-1.934-.548-2.03-.772A.29.29 0 014 16.696a.17.17 0 01.142-.176c2.31-.38 3.347-2.74 3.39-2.84l.004-.008c.141-.286.17-.535.083-.739-.159-.373-.676-.537-1.019-.645-.083-.027-.163-.052-.226-.077-.683-.27-.74-.546-.713-.688.046-.24.368-.408.628-.408a.44.44 0 01.187.038c.307.143.584.216.823.216.33 0 .475-.138.492-.157-.008-.156-.018-.319-.03-.487-.068-1.092-.153-2.448.192-3.222 1.037-2.32 3.233-2.5 3.882-2.5L12.12 5h.038c.65 0 2.852.18 3.888 2.502.346.774.26 2.132.192 3.222l-.003.048-.027.44c.017.017.15.145.449.156.228-.009.49-.081.776-.215a.586.586 0 01.241-.048c.097 0 .196.019.278.053l.005.002c.232.082.384.245.387.414.003.16-.12.4-.719.637-.062.025-.141.05-.225.077-.343.108-.86.272-1.019.645-.086.204-.059.452.083.739l.004.008c.043.1 1.078 2.459 3.39 2.84a.17.17 0 01.142.176.283.283 0 01-.024.096c-.095.223-.525.539-2.03.771-.122.019-.17.179-.243.514a5.175 5.175 0 01-.09.368c-.033.11-.101.16-.216.16h-.019c-.08 0-.192-.014-.336-.042a4.495 4.495 0 00-.903-.095c-.212 0-.432.018-.652.055-.452.075-.835.345-1.24.631-.59.416-1.198.846-2.146.846"
      fill="#000"
      fillRule="evenodd"
    />
  </svg>
);

export default Snapchat24;
